import type { FC } from 'react';
import { MarketsPage } from './MarketsPage';

export const BuyPage: FC = () => {
  return <MarketsPage type="buy" />;
};

export const PricesPage: FC = () => {
  return <MarketsPage type="price" />;
};
